import React, { useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert2";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [errors, setErrors] = useState({
    email: "",
  });

  // ** Validate if form is filled **
  const isFormValid = formData.name && formData.email && formData.message && !errors.email;

  const clearForm = () => {
    setFormData({ name: "", email: "", message: "" });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      setErrors({
        ...errors,
        email: emailRegex.test(value) ? "" : "❌ Invalid email format",
      });
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    if (!isFormValid) {
      swal.fire({
        title: "Error",
        text: "Please fill in all required fields correctly!",
        icon: "error",
      });
      return;
    }

    setLoading(true); // Start loading

    const formDataToSend = new FormData(event.target);
    formDataToSend.append("access_key", "1b494ad7-fdf0-472a-963e-7eebcfec5e6a");

    const object = Object.fromEntries(formDataToSend);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: json,
      }).then((res) => res.json());

      if (res.success) {
        swal.fire({
          title: "Thank You!",
          text: "Message sent successfully!",
          icon: "success",
        });
        clearForm();
      } else {
        swal.fire({
          title: "Error",
          text: "Message sending failed!",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setTimeout(() => setLoading(false), 1300);
    }
  };

  return (
    <div className="contact-container" href="contact" style={{ marginTop: "150px" }}>
      <Link to="/" className="absolute exitButton">
        <i className="fa fa-arrow-left" aria-hidden="true"></i>
      </Link>

      <h2 className="contact-title">Get in Touch</h2>
      <p className="contact-description">
        Have a question or want to work with us? Fill out the form below.
      </p>

      <form className="contact-form" onSubmit={onSubmit}>
        <div className="input-group">
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          <label className={formData.name ? "hidden-label" : ""}>Name</label>
        </div>

        <div className="input-group">
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          <label className={formData.email ? "hidden-label" : ""}>Email</label>
          {errors.email && <small className="error-message">{errors.email}</small>}
        </div>

        <div className="input-group">
          <textarea name="message" value={formData.message} onChange={handleChange} rows="5" required></textarea>
          <label className={formData.message ? "hidden-label" : ""}>Message</label>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? <span className="spinner"></span> : "Send Message"}
        </button>
      </form>
    </div>
  );
};

export default Contact;
